import styled from "styled-components/macro";

import logoText from "Payments/CreditCardAssets/LargeCardLogos/mastercard_text.png";
import { motion } from "framer-motion";

import { Shine, iPhone, iPhoneMini } from "../styles";

export default function Visa({ isAlreadyExisting }) {
  return (
    <>
      <Background
        initial={isAlreadyExisting ? {} : { opacity: 0 }}
        animate={{ opacity: 1, transition: { delay: 0.2 } }}
        exit={{ opacity: 0 }}
      />
      <LargeCircle
        initial={isAlreadyExisting ? {} : { opacity: 0, y: 80, scale: 1.4 }}
        animate={{
          opacity: 1,
          y: 0,
          scale: 1,
          transition: { delay: 0.3, duration: 0.4 },
        }}
        exit={{ opacity: 0, y: 80, scale: 1.4, transition: { type: "tween" } }}
      />
      <ClearCircle
        initial={isAlreadyExisting ? {} : { opacity: 0, y: -40 }}
        animate={{
          opacity: 1,
          y: 0,
          transition: { type: "tween" },
        }}
        exit={{ opacity: 0, y: -40, transition: { type: "tween" } }}
      />
      <DotsHolder>
        <Dot1
          initial={isAlreadyExisting ? {} : { x: 80, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          exit={{ x: -80, opacity: 0, transition: { type: "tween" } }}
        />
        <Dot2
          initial={isAlreadyExisting ? {} : { x: 80, opacity: 0 }}
          animate={{ x: 0, opacity: 1, transition: { delay: 0.1 } }}
          exit={{ x: -80, opacity: 0, transition: { type: "tween" } }}
        />
        <Dot3
          initial={isAlreadyExisting ? {} : { x: 80, opacity: 0 }}
          animate={{ x: 0, opacity: 0.5, transition: { delay: 0.1 } }}
          exit={{ x: -80, opacity: 0, transition: { type: "tween" } }}
        />
      </DotsHolder>
      <Logo
        src={logoText}
        initial={isAlreadyExisting ? {} : { x: -80, opacity: 0 }}
        animate={{ scale: 1, x: 0, opacity: 1 }}
        exit={{ x: -80, opacity: 0, transition: { type: "tween" } }}
      />
      <Shine />
    </>
  );
}

const Background = styled(motion.div)`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-image: linear-gradient(to top right, #243545, #384653);
`;

const Logo = styled(motion.img)`
  position: absolute;
  top: 40px;
  left: 44px;
  width: 100px;
  @media screen and (max-width: ${iPhone.cssWidth}) {
    top: auto;
    left: 36px;
    bottom: ${iPhone.logoBottom};
    margin-bottom: -8px;
  }
  @media screen and (max-width: ${iPhoneMini.cssWidth}) {
    left: 26px;
    bottom: ${iPhoneMini.logoBottom};
  }
`;

const ClearCircle = styled(motion.div)`
  width: 100%;
  position: absolute;
  aspect-ratio: 1 /1;
  border: 2px solid rgba(255, 255, 255, 0.4);
  left: 35%;
  bottom: 40%;
  border-radius: 100%;
`;

const LargeCircle = styled(motion.div)`
  position: absolute;
  border-radius: 100%;
  aspect-ratio: 1;
  width: 120%;
  background-image: linear-gradient(
    to bottom left,
    rgba(74, 88, 101, 1),
    rgba(74, 88, 101, 0),
    rgba(74, 88, 101, 0)
  );
  left: 50%;
  margin-left: -60%;
  top: 12px;
`;

const DotsHolder = styled.div`
  position: absolute;
  right: 20px;
  top: 20px;
  width: 120px;
  height: 52px;
  display: flex;
  align-items: center;
  @media screen and (max-width: ${iPhone.cssWidth}) {
    top: auto;
    bottom: ${iPhone.logoBottom};
    margin-bottom: -26px;
  }
  @media screen and (max-width: ${iPhoneMini.cssWidth}) {
    bottom: ${iPhoneMini.logoBottom};
  }
`;

const Dot1 = styled(motion.div)`
  position: absolute;
  width: 48px;
  height: 48px;
  border-radius: 48px;
  background: #e91d26;
  z-index: 5;
  right: 32px;
  @media screen and (max-width: ${iPhone.cssWidth}) {
    width: 42px;
    height: 42px;
    right: 26px;
  }
  @media screen and (max-width: ${iPhoneMini.cssWidth}) {
    width: 36px;
    height: 36px;
    right: 24px;
  }
`;
const Dot2 = styled(Dot1)`
  background: #f39e1f;
  z-index: 2;
  right: 0;
`;
const Dot3 = styled(Dot2)`
  opacity: 0.6;
  z-index: 10;
`;
